// src/LandingPage.jsx
// Public marketing homepage — served at /
// Sign-in lives at /signin, pricing at /pricing.
import React from "react";
import { Link } from "react-router-dom";

const S = {
  // page
  page: {
    background: "#080808",
    color: "#eaeaea",
    fontFamily: "'Mulish', system-ui, -apple-system, sans-serif",
    fontSize: 16,
    lineHeight: 1.6,
    WebkitFontSmoothing: "antialiased",
  },
  // nav
  nav: {
    position: "sticky",
    top: 0,
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 40px",
    background: "rgba(8,8,8,0.90)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    borderBottom: "1px solid #1c1c1c",
  },
  logoMark: { height: 32, width: "auto", display: "block", opacity: 0.9 },
  navLinks: { display: "flex", alignItems: "center", gap: 8 },
  ghost: {
    fontSize: 13,
    fontWeight: 600,
    color: "#a8a8a8",
    textDecoration: "none",
    padding: "8px 14px",
    borderRadius: 7,
  },
  pill: {
    fontSize: 13,
    fontWeight: 700,
    color: "#eaeaea",
    textDecoration: "none",
    padding: "8px 16px",
    borderRadius: 9999,
    border: "1px solid #282828",
  },
  // hero
  hero: {
    minHeight: "40vh",
    display: "flex",
    alignItems: "center",
    padding: "12px 0 12px",
    textAlign: "center",
    background:
      "radial-gradient(100% 45% at 50% -10%, rgb(68, 68, 68) 0%, transparent 48%)",
    borderBottom: "1px solid #1c1c1c",
  },
  heroFtti: {
    width: "100%",
    maxWidth: 320,
    height: "auto",
    display: "block",
    margin: "0 auto 36px",
    opacity: 0.92,
  },
  btnRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  btnRed: {
    display: "inline-block",
    padding: "14px 30px",
    background: "#c92d2d",
    color: "#fff",
    fontSize: 15,
    fontWeight: 700,
    textDecoration: "none",
    borderRadius: 9999,
  },
  btnOutline: {
    display: "inline-block",
    padding: "14px 30px",
    background: "transparent",
    color: "#eaeaea",
    fontSize: 15,
    fontWeight: 600,
    textDecoration: "none",
    borderRadius: 9999,
    border: "1px solid #282828",
  },
  // sections
  section: { padding: "104px 40px" },
  sectionAlt: {
    padding: "104px 40px",
    background: "#0d0d0d",
    borderTop: "1px solid #1c1c1c",
    borderBottom: "1px solid #1c1c1c",
  },
  wrap: { maxWidth: 1040, margin: "0 auto" },
  wrapSm: { maxWidth: 680, margin: "0 auto" },
  wrapMd: { maxWidth: 860, margin: "0 auto" },
  sectionTag: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    color: "#4a4a4a",
    marginBottom: 28,
    display: "block",
  },
  h2: {
    fontSize: "clamp(30px, 4.5vw, 52px)",
    fontWeight: 800,
    lineHeight: 1.12,
    letterSpacing: "-0.025em",
    marginBottom: 16,
  },
  // chat
  chatThread: {
    background: "#0d0d0d",
    border: "1px solid #282828",
    borderRadius: 18,
    padding: "28px 24px",
    margin: "36px 0 32px",
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  bubbleRow: { display: "flex", flexDirection: "column", gap: 3 },
  bubbleRowRight: {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    alignItems: "flex-end",
  },
  who: {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "0.07em",
    textTransform: "uppercase",
    color: "#4a4a4a",
    padding: "0 4px",
  },
  bubbleArtist: {
    display: "inline-block",
    maxWidth: "80%",
    padding: "11px 16px",
    borderRadius: 16,
    borderBottomLeftRadius: 4,
    fontSize: 14,
    lineHeight: 1.45,
    background: "#181818",
    border: "1px solid #242424",
    color: "#eaeaea",
  },
  bubbleClient: {
    display: "inline-block",
    maxWidth: "80%",
    padding: "11px 16px",
    borderRadius: 16,
    borderBottomRightRadius: 4,
    fontSize: 14,
    lineHeight: 1.45,
    background: "#160d0d",
    border: "1px solid #2b1818",
    color: "#dbbdbd",
  },
  painClose: {
    fontSize: 16,
    fontWeight: 300,
    fontStyle: "italic",
    color: "#a8a8a8",
    lineHeight: 1.7,
  },
  // steps
  steps: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 48,
    marginTop: 56,
  },
  step: { display: "flex", flexDirection: "column", gap: 14 },
  stepWord: {
    fontSize: 28,
    fontWeight: 800,
    letterSpacing: "-0.025em",
    color: "#c92d2d",
    lineHeight: 1,
    marginBottom: 2,
  },
  stepH3: {
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: "-0.01em",
    color: "#eaeaea",
  },
  stepP: { fontSize: 14, color: "#a8a8a8", lineHeight: 1.65 },
  // features
  featGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 2,
    background: "#1c1c1c",
    border: "1px solid #1c1c1c",
    borderRadius: 18,
    overflow: "hidden",
    marginTop: 52,
  },
  feat: {
    background: "#080808",
    padding: "32px 28px",
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  featIcon: { fontSize: 24, lineHeight: 1 },
  featH3: { fontSize: 15, fontWeight: 700 },
  featP: { fontSize: 13.5, color: "#a8a8a8", lineHeight: 1.6, flex: 1 },
  featTag: {
    display: "inline-block",
    fontSize: 10,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    color: "#4a4a4a",
    padding: "4px 8px",
    border: "1px solid #282828",
    borderRadius: 4,
    width: "fit-content",
    marginTop: 4,
  },
  // cta
  ctaBg: {
    padding: "104px 40px",
    background:
      "radial-gradient(ellipse 100% 60% at 50% 110%, #444444 0%, transparent 70%)",
    borderTop: "1px solid #1c1c1c",
    textAlign: "center",
  },
  ctaTagline: {
    width: "100%",
    maxWidth: 130,
    height: "auto",
    display: "block",
    margin: "0 auto 20px",
    opacity: 0.75,
  },
  ctaBig: {
    fontSize: "clamp(28px, 4vw, 48px)",
    fontWeight: 800,
    letterSpacing: "-0.025em",
    lineHeight: 1.1,
    marginBottom: 16,
  },
  ctaSub: {
    fontSize: "clamp(15px, 1.8vw, 19px)",
    fontWeight: 300,
    fontStyle: "italic",
    color: "#a8a8a8",
    marginBottom: 40,
  },
  // footer
  footer: {
    borderTop: "1px solid #1c1c1c",
    padding: "28px 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 16,
  },
  footerWordmark: { height: 22, width: "auto", opacity: 0.35 },
  footerLinks: { display: "flex", gap: 24, alignItems: "center" },
  footerLink: { fontSize: 12, color: "#4a4a4a", textDecoration: "none" },
  deviceBadges: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginTop: 18,
    marginBottom: 4,
  },

  deviceBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "7px 11px",
    borderRadius: 9999,
    border: "1px solid #282828",
    background: "#0d0d0d",
    color: "#a8a8a8",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "0.02em",
  },
};

export default function LandingPage() {
  return (
    <div style={S.page}>
      {/* Google Fonts */}
      <link
        href="https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400&display=swap"
        rel="stylesheet"
      />

      <style>{`
  @media (max-width: 760px) {
    .lp-nav {
      padding: 12px 18px !important;
    }

    .lp-navlinks {
      gap: 4px !important;
    }

    .lp-navlinks a {
      font-size: 12px !important;
      padding: 7px 10px !important;
    }

    .lp-hero-inner {
      width: 100% !important;
      padding: 0 0px !important;
    }

    .lp-section {
      padding: 32px 10px !important;
    }

    .lp-steps {
      grid-template-columns: 1fr !important;
      gap: 34px !important;
      margin-top: 42px !important;
    }

    .lp-feature-grid {
      grid-template-columns: 1fr !important;
    }

    .lp-footer {
      padding: 28px 22px !important;
      align-items: flex-start !important;
    }

    .lp-footer-links {
      flex-wrap: wrap !important;
      gap: 14px 22px !important;
    }
  }
`}</style>

      {/* ── NAV ────────────────────────────────────────────────── */}
      <nav className="lp-nav" style={S.nav}>
        <Link
          to="/"
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
        >
          <img src="/tattune-logo-grey.svg" alt="Tattune" style={S.logoMark} />
        </Link>
        <div className="lp-navlinks" style={S.navLinks}>
          <Link to="/artists" style={S.ghost}>
            Browse artists
          </Link>
          <Link to="/pricing" style={S.ghost}>
            Pricing
          </Link>
          <Link to="/signin" style={S.pill}>
            Artist sign-in →
          </Link>
        </div>
      </nav>

      {/* ── HERO ───────────────────────────────────────────────── */}
      <section style={S.hero}>
        <div style={{ ...S.wrapSm, width: "70%", padding: "0 24px" }}>
          <img
            src="/tattune-ftti-grey.svg"
            alt="From Think To Ink"
            style={S.heroFtti}
          />
          <div style={S.btnRow}>
            <Link to="/signin" style={S.btnRed}>
              Try it free →
            </Link>
            <Link to="/artists" style={S.btnOutline}>
              Browse Artists
            </Link>
          </div>
          <div
            style={{
              marginTop: 56,
              textAlign: "center",
            }}
          >
            <img
              src="/screenshots/hero-mobile.jpg"
              alt="Comments and annotations"
              style={{
                width: "100%",
                maxWidth: 360,
                borderRadius: 20,
                border: "1px solid #282828",
              }}
            />
          </div>
        </div>
      </section>

      {/* ── PAIN POINT ─────────────────────────────────────────── */}
      <section className="lp-section" style={S.section}>
        <div
          className="lp-hero-inner"
          style={{ ...S.wrapSm, width: "50%", padding: "0 24px" }}
        >
          <span style={S.sectionTag}>Sound familiar?</span>
          <div style={S.chatThread}>
            <div style={S.bubbleRowRight}>
              <span style={S.who}>You</span>
              <span style={S.bubbleClient}>
                I love this design but I can't figure out the right size 😬
              </span>
            </div>
            <div style={S.bubbleRow}>
              <span style={S.who}>Artist</span>
              <span style={S.bubbleArtist}>What are you thinking?</span>
            </div>
            <div style={S.bubbleRowRight}>
              <span style={S.who}>You</span>
              <span style={S.bubbleClient}>
                Somewhere on my forearm? Medium? I've never gotten one before so
                it's hard to say
              </span>
            </div>
            <div style={S.bubbleRow}>
              <span style={S.who}>Artist</span>
              <span style={S.bubbleArtist}>
                That could mean a lot of things 😄 Can you show me where?
              </span>
            </div>
            <div style={S.bubbleRowRight}>
              <span style={S.who}>You</span>
              <span style={S.bubbleClient}>
                I took a photo but it doesn't really help... I just don't want
                to commit to something and regret the placement
              </span>
            </div>
          </div>
          <p style={S.painClose}>
            Your artist is talented. The design is perfect. The only thing
            missing is seeing it{" "}
            <strong
              style={{ fontStyle: "normal", fontWeight: 700, color: "#eaeaea" }}
            >
              on your body, in context, before it's permanent.
            </strong>
          </p>
        </div>
      </section>

      {/* ── HOW IT WORKS ───────────────────────────────────────── */}
      <section className="lp-section" style={S.sectionAlt}>
        <div style={{ ...S.wrapMd, padding: 0 }}>
          <span style={S.sectionTag}>How it works</span>
          <h2 style={S.h2}>Design. Refine. Enshrine.</h2>
          <div className="lp-steps" style={S.steps}>
            <div style={S.step}>
              <div style={S.stepWord}>Design.</div>
              <h3 style={S.stepH3}>Place your vision</h3>
              <p style={S.stepP}>
                Upload any flash, reference image, or custom piece and position
                it on the Plannequin — an interactive body placement guide. See
                it in context before you commit.
              </p>
            </div>
            <div style={S.step}>
              <div style={S.stepWord}>Refine.</div>
              <h3 style={S.stepH3}>Get it exactly right</h3>
              <p style={S.stepP}>
                Try different placements and sizes. Draw, annotate, compare,
                comment, and share ideas directly on the Plannequin before
                anything becomes permanent.
              </p>
            </div>
            <div style={S.step}>
              <div style={S.stepWord}>Enshrine.</div>
              <h3 style={S.stepH3}>Book with confidence</h3>
              <p style={S.stepP}>
                Share your Plannequin placement with your artist before the
                appointment. Walk in knowing. Walk out with the tattoo you
                imagined, exactly where you wanted it.
              </p>
            </div>
          </div>
          <img
            src="/screenshots/placement-shoulder-mobile.jpg"
            alt="Tattoo placement on Plannequin"
            style={{
              display: "block",
              width: "100%",
              maxWidth: 420,
              margin: "22px auto 0",
              borderRadius: 24,
              border: "1px solid #282828",
              boxShadow: "0 30px 60px rgba(0,0,0,.45)",
            }}
          />
          <p
            style={{
              textAlign: "center",
              color: "#a8a8a8",
              fontSize: 14,
              marginTop: 18,
            }}
          >
            Compare placements and sizes before anything becomes permanent.
          </p>
        </div>
      </section>

      {/* ── FEATURES ───────────────────────────────────────────── */}
      <section className="lp-section" style={S.section}>
        <div style={{ ...S.wrapMd, padding: 0 }}>
          <span style={S.sectionTag}>Built for the real conversation.</span>
          <h2 style={S.h2}>
            Everything between
            <br />
            "I want a tattoo"
            <br />
            and the chair.
          </h2>
          <div className="lp-feature-grid" style={S.featGrid}>
            <div style={S.feat}>
              <div style={S.featIcon}>🧍</div>
              <h3 style={S.featH3}>The Plannequin</h3>
              <p style={S.featP}>
                A body placement guide for trying designs in context. Scale,
                rotate, and position your design — then morph the Plannequin
                itself to match your proportions, body type, and build. What you
                see is what you get.
              </p>
              <div
                style={{
                  marginTop: 18,
                  paddingBottom: 0,
                  textAlign: "center",
                }}
              >
                <img
                  src="/screenshots/plannequin-mobile.jpg"
                  alt="Comments and annotations"
                  style={{
                    width: "100%",
                    maxWidth: 360,
                    borderRadius: 20,
                    border: "1px solid #282828",
                  }}
                />
              </div>
              <p
                style={{
                  color: "#a8a8a8",
                  fontSize: 14,
                  marginTop: 18,
                }}
              >
                Fully customizeable. Any angle, any skin colour, any gender, any
                physique.
              </p>

              <span style={S.featTag}>Placement</span>
            </div>

            <div style={S.feat}>
              <div style={S.featIcon}>⚡</div>
              <h3 style={S.featH3}>Flash libraries</h3>
              <p style={S.featP}>
                Artists publish their flash directly to Tattune. Browse, save,
                and try pieces from local studios before you ever reach out.
                Know what you love before you ask.
              </p>
              <div
                style={{
                  marginTop: 18,
                  paddingBottom: 0,
                  textAlign: "center",
                }}
              >
                <img
                  src="/screenshots/flash-gallery-mobile.jpg"
                  alt="Flash gallery"
                  style={{
                    width: "100%",
                    maxWidth: 360,
                    borderRadius: 20,
                    border: "1px solid #282828",
                  }}
                />
              </div>
              <p
                style={{
                  color: "#a8a8a8",
                  fontSize: 14,
                  marginTop: 18,
                }}
              >
                Try on the latest flash, send your plannequin & book with the
                artist directly.
              </p>
              <span style={S.featTag}>Discovery</span>
            </div>
            <div style={S.feat}>
              <div style={S.featIcon}>🔗</div>
              <h3 style={S.featH3}>Share your design & placement</h3>
              <p style={S.featP}>
                Export and share exactly what you're picturing — placement,
                scale, rotation, drawings, annotations, and comments included.
                Your artist sees what you see. No more "somewhere on my arm,
                kinda medium."
              </p>
              <div
                style={{
                  marginTop: 18,
                  paddingBottom: 0,
                  textAlign: "center",
                }}
              >
                <img
                  src="/screenshots/comments-mobile.jpg"
                  alt="Comments and annotations"
                  style={{
                    width: "100%",
                    maxWidth: 360,
                    borderRadius: 20,
                    border: "1px solid #282828",
                  }}
                />
              </div>
              <p
                style={{
                  color: "#a8a8a8",
                  fontSize: 14,
                  marginTop: 18,
                }}
              >
                Draw, annotate and collaborate directly on the Plannequin.
              </p>
              <span style={S.featTag}>Collaboration</span>
            </div>
            <div style={S.feat}>
              <div style={S.featIcon}>📱</div>
              <h3 style={S.featH3}>No app to install</h3>
              <p style={S.featP}>
                Just tattune.ca. Works in any browser on any device. Browse
                artists and try placements without creating an account — sign up
                when you're ready to connect.
              </p>

              <div style={S.deviceBadges}>
                {["iPhone", "Android", "Tablet", "Desktop"].map((item) => (
                  <span key={item} style={S.deviceBadge}>
                    {item}
                  </span>
                ))}
              </div>

              <div
                style={{
                  marginTop: 18,
                  paddingBottom: 0,
                  textAlign: "center",
                }}
              >
                <img
                  src="/screenshots/browser-mobile.jpg"
                  alt="Tattune running in a mobile browser"
                  style={{
                    width: "100%",
                    maxWidth: 360,
                    borderRadius: 20,
                    border: "1px solid #282828",
                  }}
                />
              </div>

              <p
                style={{
                  color: "#a8a8a8",
                  fontSize: 14,
                  marginTop: 18,
                }}
              >
                Work right in your browser. Save on one device and continue on
                another — no apps, no downloads, no manual updates.
              </p>

              <span style={S.featTag}>Accessible</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA ────────────────────────────────────────────────── */}
      <section style={S.ctaBg}>
        <div style={{ ...S.wrapSm, padding: 0 }}>
          <img
            src="/tattune-tagline-grey.svg"
            alt="Tattune"
            style={S.ctaTagline}
          />
          <p style={S.ctaBig}>View it before you do it.</p>
          <p style={S.ctaSub}>From imagination to pigmentation.</p>
          <div style={S.btnRow}>
            <Link to="/signin" style={S.btnRed}>
              Try it free →
            </Link>
            <Link to="/artists" style={S.btnOutline}>
              Browse artists
            </Link>
          </div>
        </div>
      </section>

      {/* ── FOOTER ─────────────────────────────────────────────── */}
      <footer className="lp-footer" style={S.footer}>
        <img
          src="/tattune-tagline-grey.svg"
          alt="Tattune"
          style={S.footerWordmark}
        />
        <div className="lp-footer-links" style={S.footerLinks}>
          <Link to="/artists" style={S.footerLink}>
            Browse artists
          </Link>
          <Link to="/pricing" style={S.footerLink}>
            Pricing
          </Link>
          <Link to="/privacy" style={S.footerLink}>
            Privacy
          </Link>
          <Link to="/signin" style={S.footerLink}>
            Artist sign-in
          </Link>
        </div>
      </footer>
    </div>
  );
}
